import React from 'react'

type EmojiProps = {
  label?: string
  symbol: string
  url?: string
}
export const Emoji: React.FC<EmojiProps> = ({ label, symbol, url }) => {
  return (
    <span
      className="emoji"
      role="img"
      aria-label={label ? label : ''}
      aria-hidden={label ? 'false' : 'true'}
    >
      {symbol}
      {url && ' ' + url}
    </span>
  )
}
